import React from 'react';
import {getValueAfterLastSlash, isMobile, providerTypes} from '../sessionBroadcastUtils';
import {Vimeo} from '../VirtualSessions/Vimeo';
import {Youtube} from '../VirtualSessions/Youtube';
import {LiveStream} from '../VirtualSessions/Livestream';
import {Brightcove, CustomPlayer, HlsPlayer} from '@bizzabo/broadcast';
import webcastingType from '../../../../web-common/scripts/enums/webcastingTypeEnum';
import FeatureToggleUtils from 'FeatureToggleUtils';

function EmbedViewWrapper(
    {
        virtualSessionDetails,
        isBizzaboQnaActive,
        isIframeLoading,
        setIsIframeLoading,
        isMobileApp = false,
        canPlay = true
    }
) {
    const isMobileDevice = isMobile();
    if (!virtualSessionDetails || virtualSessionDetails.type !== webcastingType.EMBEDDED) {
        return null;
    }

    const versionToScriptUrls = {
        plyr: FeatureToggleUtils.getFeatureValue('bap-plyr-io-version'),
        hls: FeatureToggleUtils.getFeatureValue('bap-hls-js-version'),
        mux: FeatureToggleUtils.getFeatureValue('bap-mux-player-version'),
    };

    const bizzaboAgnosticPlayer = FeatureToggleUtils.getFeatureValue('bizzabo-agnostic-player');

    if (virtualSessionDetails.providerType === providerTypes.VIMEO) {
        const { videoId, chatEnabled } = virtualSessionDetails;
        return (
            <Vimeo
                videoId={videoId}
                isFullWidth={!chatEnabled || isBizzaboQnaActive || isMobileDevice}
                showOwnChat={chatEnabled && !isBizzaboQnaActive}
                isIframeLoading={isIframeLoading}
                setIsIframeLoading={setIsIframeLoading}
                isMobileApp={isMobileApp}
            />
        );
    }
    if (virtualSessionDetails.providerType === providerTypes.YOUTUBE) {
        const streamId = getValueAfterLastSlash(virtualSessionDetails.streamId);
        return (
            <Youtube
                streamId={streamId}
                isIframeLoading={isIframeLoading}
                setIsIframeLoading={setIsIframeLoading}
                isMobileApp={isMobileApp}
                canPlay={canPlay}
            />
        );
    }
    if (virtualSessionDetails.providerType === providerTypes.BRIGHTCOVE) {
        const { videoId } = virtualSessionDetails;
        return (
            <Brightcove
                videoId={videoId}
                isIframeLoading={isIframeLoading}
                onLoad={() => setIsIframeLoading(false)}
                allowFullScreen
                isFullWidth
            />
        );
    }
    if (virtualSessionDetails.providerType === providerTypes.LIVESTREAM) {
        return (
            <LiveStream
                virtualSessionDetails={virtualSessionDetails}
                isIframeLoading={isIframeLoading}
                setIsIframeLoading={setIsIframeLoading}
                isMobileApp={isMobileApp}
            />
        );
    }
    if (virtualSessionDetails.providerType === providerTypes.HLS) {
        const streamUrl = virtualSessionDetails.hlsStreamUrl;
        return (
            <HlsPlayer
                streamUrl={streamUrl}
                versionToScriptUrls={versionToScriptUrls}
                bizzaboAgnosticPlayer={bizzaboAgnosticPlayer}
            />
        );
    }
    if (virtualSessionDetails.providerType === providerTypes.CUSTOM) {
        const playerUrl = virtualSessionDetails.customPlayerUrl;
        return (
            <CustomPlayer
                videoId={playerUrl}
                isIframeLoading={isIframeLoading}
                onLoad={() => setIsIframeLoading(false)}
                allowFullScreen
                isFullWidth
            />
        );
    }
}

export default React.memo(EmbedViewWrapper);
